"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArwesThemeProvider = void 0;
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_2 = require("@emotion/react");
var design_1 = require("@arwes/design");
var ArwesThemeProvider = function (props) {
    var themeSettings = props.themeSettings, children = props.children;
    var theme = react_1.useMemo(function () {
        var _a;
        return design_1.createTheme(__assign(__assign({}, themeSettings), { breakpoints: themeSettings === null || themeSettings === void 0 ? void 0 : themeSettings.breakpoints, palette: __assign(__assign({ primary: {
                    light3: '#befcfe',
                    light2: '#7efcf6',
                    light1: '#3efbfb',
                    main: '#00f8f8',
                    dark1: '#05c6c1',
                    dark2: '#0b8481',
                    dark3: '#15333c'
                }, secondary: {
                    light3: '#ffece1',
                    light2: '#ffe4d2',
                    light1: '#ffc69f',
                    main: '#ffa76c',
                    dark1: '#f66901',
                    dark2: '#e24a0f',
                    dark3: '#a32d08'
                }, neutral: {
                    main: '#021114'
                } }, themeSettings === null || themeSettings === void 0 ? void 0 : themeSettings.palette), { text: __assign({ root: '#7efcf6', headings: '#00f8f8', link: '#ffa76c', linkHover: '#ffc69f' }, (_a = themeSettings === null || themeSettings === void 0 ? void 0 : themeSettings.palette) === null || _a === void 0 ? void 0 : _a.text) }) }));
    }, []);
    return (react_1.default.createElement(react_2.ThemeProvider, { theme: theme }, children));
};
exports.ArwesThemeProvider = ArwesThemeProvider;
ArwesThemeProvider.propTypes = {
    themeSettings: prop_types_1.default.object
};
